import PropTypes from 'prop-types';
import FJLocalStore from '../../../../../store/FJLocalStore';
import FJButton, { FJButtonType } from '../../../../../common/components/FJButton/FJButton';
import FJConfig from '../../../../../config/FJConfig';
import FJVersionConfig from '../../../../../config/FJVersionConfig';
import FJHeadshotGeneratorConfig from '../../../../../config/appConfig/FJHeadshotGeneratorConfig';

import styles from './FJGeneratingPlaceholder.module.less';

const FJGeneratingPlaceholder = ({ onBack }) => {
    const handleExplore = () => {
        window.open(FJConfig.FLEXCLIP_PRODUCTION_URL_AI, '_blank');
    };
    return (
        <div className={styles.container}>
            <div className={styles.generation_section}>
                <div className={styles.generation_animation}>
                    <video
                        src={`${FJHeadshotGeneratorConfig.generatingPlaceholderVideoUrl}mobius-white.mp4?v=${FJVersionConfig.staticPathVersion}`}
                        autoPlay
                        loop
                        muted
                        disablePictureInPicture
                    />
                </div>
                <div className={styles.generation_info}>
                    <h4>{FJLocalStore._('photo-generating')}</h4>
                    <p>{FJLocalStore._('avatar-generating-info')}</p>
                </div>
                <FJButton
                    text={FJLocalStore._('explore-flexclip-ai')}
                    type={FJButtonType.GRADIENT}
                    className={styles.generating_button}
                    onClick={handleExplore}
                />
                <FJButton
                    text={FJLocalStore._('back-to-home')}
                    type={FJButtonType.DEFAULT}
                    className={styles.back_button}
                    onClick={onBack}
                />
            </div>
        </div>
    );
};

FJGeneratingPlaceholder.propTypes = {
    onExplore: PropTypes.func,
    onBack: PropTypes.func,
};

export default FJGeneratingPlaceholder;
